
/**
 * Custom component for Bimini steak section.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.1.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-03-23 (1.0.0) (jhoward)
 *      - <biminiSteakSection> adds customizations for the Bimini steak menu section.
 *
 *    2023-03-27 (1.0.1) (jhoward)
 *      - Fix menu version placement in <biminiSteakSection>.
 *
 *    2025-04-08 (1.2.0) (jhoward)
 *    - Replace "menuVersion" prop with "menu" prop <bimini-steak-section>.
 *    - Remove "visual_" and "textual_" prefixes from class names in <bimini-steak-section>.
 */

import {defineComponent, PropType} from "vue";
import BiminiDefaultSection from "./Bimini_defaultSection.vue";
import {Menu, MenuSection} from "../defs";

export default defineComponent({
  name: 'Bimini_steakSection',
  components: {BiminiDefaultSection},
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
  computed: {
    isWagyuSection(): boolean {
      return /(^|\s)wagyu(\s|$)/i.test(this.section.ms_title);
    }
  },
})
